import { opaccAjaxPlugin, opaccLogPlugin } from '../opacc.static.js';
import { favoriteMessages, generalMessages } from '../messages/opacc.messages.js';
import { OpaccFormValidator } from './opacc.class.formvalidator.js';

/** @module favorite */

/**
 * Funktionalität für die Favoriten
 * @property {HTMLElement} contentContainer Container for Event-Registration
 * @property {NodeList} countContainer List with all favorite counter
 * @property {Object} requestData Object initialization for Data submission
 * @property {Object} messages Object with translated text
 * @property {string} modalWindowSelector String-Selector for Modal Container
 */
export class OpaccFavorite {
	constructor() {
		this.contentContainer = document.querySelector('body');
		this.countContainer = document.querySelectorAll('.favorite-count');
		this.requestData = {};
		this.messages = Object.assign({},favoriteMessages, generalMessages);
		this.modalWindowSelector = '.opc-favorite-modal';
		this.attachEventListener();
	}

	/**
	 * Event Registrierung im DOM
	 *
	 */
	attachEventListener() {
		if (this.contentContainer) {

			this.contentContainer.addEventListener('click', event => {
				let button = event.target.closest('[data-op-multifavoritesaction]');
				if (button) {
					this.selectFavoriteList(button);
				}

				let deleteBtn = event.target.closest('#delete-form .opc-button');
				if (deleteBtn && deleteBtn.type == 'submit') {
					event.preventDefault();
					opaccLogPlugin.showConfirm(this.messages.messageDeleteConfirmation.text, this.messages.messageOk.text, this.messages.messageCancel.text, this.confirmDeletionFavoriteList.bind(this,deleteBtn), undefined, undefined, 'confirm-delete');
				}
			});
		}
	}

	/**
	 *
	 *
	 * @param {*} button
	 */
	selectFavoriteList(button) {
		this.checkMaximum(button).then((resolve) => {
			if (resolve) {
				if (button.dataset.opMultifavoritesaction === 'added') {
					button.classList.add('is-progress');
				}
				this.sendAjaxRequest(button);
			}
		});
	}

	/**
	 *
	 *
	 * @param {*} button
	 */
	confirmDeletionFavoriteList(button) {
		let deleteForm = button.closest('form');
		deleteForm.submit();
	}

	/**
	 *
	 *
	 * @param {*} item
	 * @returns {*}
	 */
	checkMaximum(item) {
		let action = item.dataset.opMultifavoritesaction;
		let countList = Number(this.countContainer[0] ? this.countContainer[0].textContent : 0);
		let countPosition = Number(item.querySelector('.favorite-list-item-count') ? item.querySelector('.favorite-list-item-count').textContent : 0);
		let maxList = Number(item.dataset.opMaxlist);
		let maxPosition = Number(item.dataset.opMaxposition);
		let nameField = this.contentContainer.querySelector('.favorite-modal-footer input');
		let name = nameField ? nameField.value : '';
		let target = item.dataset.opSaldocboidtarget;
		// eslint-disable-next-line no-unused-vars
		let type = '';
		let valid = true;
		if (action === 'added' || action === 'moved')
		{
			// Maximale Anzahl Positionen pruefen
			if (target && maxPosition > 0 && countPosition >= maxPosition) {
				valid = false;
				opaccLogPlugin.showMessage(this.messages.messageMaxPositions);
			}
			// Maximale Anzahl Merklisten pruefen
			else if (!target && name && maxList > 0 && countList >= maxList) {
				valid = false;
				opaccLogPlugin.showMessage(this.messages.messageMaxLists);
			}
		}

		if ((action === 'added' || action === 'moved') && !target && valid) {
			nameField.dataset.opMessagePatternMismatch = this.messages.messageInvalidName.text;
			return new OpaccFormValidator(nameField.closest('.opc-form-field')).validateField(nameField);
		}

		return Promise.resolve(valid);
	}

	/**
	 *
	 *
	 * @param {*} item
	 */
	sendAjaxRequest(item) {
		let nameField = this.contentContainer.querySelector('.favorite-modal-footer input');
		this.requestData = {
			Type: 'favorite',
			ArtFavorite_ArtNo: item.dataset.opArtno,
			ArtFavorite_ArtBoId: item.dataset.opArtboid,
			ArtFavorite_ListName: nameField ? nameField.value : '',
			ArtFavorite_MultiAction: item.dataset.opMultifavoritesaction,
			ArtFavorite_OnList: item.dataset.opOnlist ? item.dataset.opOnlist : '',
			ArtFavorite_SalDocBoIdSource: item.dataset.opSaldocboidsource ? item.dataset.opSaldocboidsource : '',
			ArtFavorite_SalDocBoIdTarget: item.dataset.opSaldocboidtarget ? item.dataset.opSaldocboidtarget : '',
			maxLists: item.dataset.opMaxlist,
			maxPositions: item.dataset.opMaxposition
		};
		for (var property in item.dataset) {
			if (property.startsWith('opSaldocitem.')) {
				this.requestData[property.substring(2).toLowerCase()] = item.dataset[property];
			}
		}

		this.hookBeforeSendAjaxRequest(item);
        	let url = opaccAjaxPlugin.setAsyncUrl();
		opaccAjaxPlugin.fetchAsynPostForm(url, this.hookBeforeReturnPrepareDataSubmission(item, this.requestData), this.refreshContent.bind(this, item), this.asyncErrorHandler.bind(this), true);
	}

	/**
	 *
	 *
	 * @param {*} button
	 * @param {*} response
	 */
	refreshContent(button, response) {

		response = this.hookBeforeRefreshContent(button, response);

		if (response.success) {
			// CSS-Klassen aktualisieren
			if (this.contentContainer) {
				let items = this.contentContainer.querySelectorAll(`.opc-favorite-button[data-op-artboid="${response.dataAsJson.artBoId}"]`);
				Array.from(items).forEach(item => {
					if (response.dataAsJson.onList) {
						item.classList.add('is-active');
						item.dataset.opOnlist = response.dataAsJson.onList;
					} else {
						item.classList.remove('is-active');
					}
				});
			}
			// Artikel aus Merklisten-Ansicht entfernen
			if (response.dataAsJson.action === 'deleted' || response.dataAsJson.action === 'moved') {
				this.removeFavoriteItem(response.dataAsJson.artBoId);
			}
			// Modal-Dialog anzeigen/ausblenden
			if (response.dataAsJson.action === 'added' || response.dataAsJson.action === 'deleted' || response.dataAsJson.action === 'moved') {
				button.classList.remove('is-progress');
				opaccLogPlugin.hideModal();

				// Merklistenzaehler aktualisieren
				if (this.countContainer) {
					Array.from(this.countContainer).forEach(item => {
						item.textContent = response.dataAsJson.favoriteCount;
					});
				}

				if (response.dataAsJson.action === 'moved' && !button.dataset.opSaldocboidtarget) {
					window.location.reload();
				}

			} else {
				opaccLogPlugin.showModal(response.dataAsJson.message);
			}
			// Wechsel zwischen Hinzufügen und Löschen als Gast (nur eine Merkliste möglich)
			if (response.dataAsJson.isGuest && this.contentContainer) {
				let items = this.contentContainer.querySelectorAll(`.opc-favorite-button[data-op-artboid="${response.dataAsJson.artBoId}"]`);
				if (response.dataAsJson.action === 'added') {
					Array.from(items).forEach(item => {
						item.dataset.opMultifavoritesaction = "deleted";
						item.dataset.opOnlist = response.dataAsJson.onList;
						item.dataset.opSaldocboidtarget = response.dataAsJson.salDocBoIdTarget;
						item.title = response.dataAsJson.titleDelete;
					});
				}
				else if (response.dataAsJson.action === 'deleted') {
					Array.from(items).forEach(item => {
						item.dataset.opMultifavoritesaction = "added";
						item.dataset.opOnlist = "";
						item.dataset.opSaldocboidtarget = response.dataAsJson.salDocBoIdTarget;
						item.title = response.dataAsJson.titleAdd;
					});
				}
			}
		} else {
			button.classList.remove('is-progress');
		}

		this.hookAfterRefreshContent(button, response);
	}

	/**
	 *
	 *
	 * @param {*} artBoId
	 */
	removeFavoriteItem(artBoId) {
		if (this.contentContainer) {
			let items = this.contentContainer.querySelectorAll(`button[data-op-multifavoritesaction^="delete"][data-op-artboid="${artBoId}"]`);
			Array.from(items).forEach(item => {
				let favItem = item.closest('li[data-op-iscatitem]');
				if (favItem) {
					let parent = favItem.parentNode;
					if (parent) {
						parent.removeChild(favItem);
						if(parent.querySelectorAll('li').length == 0) {
							window.location.reload();
						}
					}
				}
			});
		}
	}

	/**
	 *
	 *
	 * @param {*} error
	 */
	asyncErrorHandler(error) {
		// eslint-disable-next-line no-console
		console.error('Request failed: ', error.message);
		this.hookAfterAsyncErrorHandler(error);
	}

	// ---------------------------------

	/**
	 *
	 *
	 * @param {*} item
	 */
	// eslint-disable-next-line no-unused-vars
	hookBeforeSendAjaxRequest(item){}

	/**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 * @returns {*}
	 */
	hookBeforeReturnPrepareDataSubmission(item, data){return data;}

	/**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 * @returns {*}
	 */
	hookBeforeRefreshContent(item, data) {return data;}

	/**
	 *
	 *
	 * @param {*} item
	 * @param {*} data
	 */
	// eslint-disable-next-line no-unused-vars
	hookAfterRefreshContent(item, data){}

	/**
	 *
	 *
	 * @param {*} error
	 */
	// eslint-disable-next-line no-unused-vars
	hookAfterAsyncErrorHandler(error){}
}